import React, { Component } from 'react';

// Modules
import EventView from './EventView';
import { getEvent } from '../../utils/eventsFunctions';
import { getTeams } from '../../utils/competitorsFunctions';
import { getStudentsFromEvent } from '../../utils/studentsFunctions';

export default class Event extends Component {

    constructor(props) {
        super(props);
        this.state = {
            event: null,
            eventId: null,

            modalRegistration: false,
            arrayOfTeams: [],
            studentsList: [],
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);
        const params = new URLSearchParams(window.location.search);
        let id = params.get('id');
        this.getEvent(id);
        this.getTeamsLocal();
        this.getEventParticipantList(id);
    };

    getEventParticipantList = async (key) => {
        const studentsList = await getStudentsFromEvent(key);
        this.setState({ studentsList });
    }

    getEvent = async (key) => {
        const event = await getEvent(key);
        this.setState({
            event: event,
            eventId: key,
        });
    }

    getTeamsLocal = async () => {
        let localArray = await getTeams();

        this.setState({
            arrayOfTeams: localArray,
        });
    }

    /* Registration modal stuffs */
    openModalRegistration = () => {
        this.setState({ modalRegistration: true })
    }

    closeModalRegistration = () => {
        this.setState({ modalRegistration: false })
    }

    render() {
        return (
            <EventView
                event={this.state.event}
                eventId={this.state.eventId}

                arrayOfTeams={this.state.arrayOfTeams}
                studentsList={this.state.studentsList}
                updateStudentList={() => this.getEventParticipantList(this.state.eventId)}

                modalRegistration={this.state.modalRegistration}
                openModalRegistration={() => this.openModalRegistration()}
                closeModalRegistration={() => this.closeModalRegistration()}
            />
        );
    }
}